import React, { useState, useEffect, useContext, useMemo } from 'react';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';
import { DynamicModalContext } from '../../../init/dynamicModals';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button, Switch } from 'antd';

import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/creatable';

import toast from 'react-hot-toast';
import KeyPad from '../../../components/keyPad/keyPad';
import { FaUserPlus } from "react-icons/fa6";

import Loader from '../../../components/loader/loader';
import CustomerForm from '../../../salesTab/customer/customerForm';

import { numberFormatter } from '../../../components/formatters/numberFormatter';


function CustomerModal(props) {

  const { showModal, toggleModal, title, selectedTab, } = props;

  const { settingData, customerAccountData, rateMainToSecondaryCurrency, rateToMainCurrency, defaultCurrency, rateSecondaryToMainCurrency,
    refData, companyId, customerAccountOptions, loadCustomerAccountOptions, isUsingMainCurrency } = useContext(DataContext);

  const { tabData, setTabData, setJournalVoucher } = useContext(PosCartContext);
  const { openAddCustomerModal, addedCustomer, setAddedCustomer } = useContext(DynamicModalContext);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);



  const cart = tabData[selectedTab].cart;
  const journalVoucher = tabData[selectedTab].journalVoucher;



  useEffect(() => {
    setInputValue("");
  }, [showModal]);


  useEffect(() => {
    if (addedCustomer) {
      let updatedJv = { ...journalVoucher };
      updatedJv.accountId = addedCustomer.id;
      setJournalVoucher(updatedJv, selectedTab)

      // ✅ add new option into the options list if not already there
      const exists = customerAccountOptions?.some(opt => opt.value === addedCustomer.id);
      if (!exists) {
        customerAccountOptions.push({
          value: addedCustomer.id,
          label: addedCustomer.accountId + '. ' + addedCustomer.english + (addedCustomer.phone ? ' [' + addedCustomer.phone + ']' : ''),

        });
      }
    }

  }, [addedCustomer]);


  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    let updatedJv = { ...journalVoucher };
    updatedJv.accountId = selectedOption?.value || null;

    setJournalVoucher(updatedJv, selectedTab)
    if (selectedOption == null) {
      setAddedCustomer(null);
    }
  };

  const closeModal = () => {

    toggleModal();
  }



  const selectedCustomer = useMemo(
    () => customerAccountOptions?.find(option => option.value === journalVoucher.accountId),
    [customerAccountOptions, journalVoucher.accountId, addedCustomer]
  );

  const handleSwitch = (value) => {
    let updatedJv = { ...journalVoucher };

    if (value == false) {
      updatedJv.pointsValue = 0;
      updatedJv.secondaryPointsValue = 0;
    }
    updatedJv.isUsingPoints = value || false;
    setJournalVoucher(updatedJv, selectedTab)
  }

  const handleInput = (e) => {
    let updatedJv = { ...journalVoucher };

    const maxValue = isUsingMainCurrency ? selectedCustomer?.points : selectedCustomer?.secondaryPoints;

    const pointsValueInput = e.target.value;

    const pointsValue = isUsingMainCurrency ? pointsValueInput : rateSecondaryToMainCurrency(pointsValueInput);
    const secondaryPointsValue = isUsingMainCurrency ? rateMainToSecondaryCurrency(pointsValueInput) : pointsValueInput;

    const usedPoints = pointsValue / selectedCustomer?.equation;
    const secondaryUsedPoints = secondaryPointsValue / selectedCustomer?.equation;

    updatedJv.pointsValue = pointsValue;
    updatedJv.secondaryPointsValue = secondaryPointsValue;
    updatedJv.usedPoints = usedPoints;
    updatedJv.secondaryUsedPoints = secondaryUsedPoints;

    setJournalVoucher(updatedJv, selectedTab)
  }


  return (
    <Modal show={showModal} onHide={toggleModal} backdrop='static'>
      <Modal.Header style={{ background: "#1d7790" }}>
        <Modal.Title style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        {isLoading &&
          <Loader />
        }

        {!isLoading &&
          <>
            <Row className="mb-4" style={{ marginTop: '4vh' }}>

              <Col>
                <AsyncSelect
                  cacheOptions
                  isClearable={true}
                  loadOptions={loadCustomerAccountOptions}
                  defaultOptions={[]}
                  onChange={(e) => handleSelectChange(e, 'accountId')}
                  value={selectedCustomer}
                  noOptionsMessage={() => 'type to view'}
                  autoFocus
                  onKeyDown={(e) => { if (e.key === 'Enter') { closeModal() } }}
                />
              </Col>

              <Col md={2}>
                <FaUserPlus size={30} style={{ cursor: 'pointer' }} onClick={openAddCustomerModal} />
              </Col>

            </Row>

            <Row className="mb-1">
              <Col md={1}>
              </Col>
              <Col md={2}>
                Type:
              </Col>

              <Col>
                {selectedCustomer?.loyaltyType}
              </Col>
            </Row>

            <Row className="mb-1">
              <Col md={1}>
              </Col>
              <Col md={2}>
                Points:
              </Col>

              <Col>
                {numberFormatter(isUsingMainCurrency ? selectedCustomer?.totalPoints : selectedCustomer?.secondaryTotalPoints)}
              </Col>
              <Col>
                {numberFormatter(isUsingMainCurrency ? selectedCustomer?.pointsValue : selectedCustomer?.secondaryPointsValue)}
              </Col>
            </Row>



            <Row className="mb-3">
              <Col md={1}>
              </Col>
              <Col md={6}>
                <Form.Label>use Points</Form.Label>
              </Col>
              <Col>
                <Switch style={{ backgroundColor: journalVoucher?.isUsingPoints ? '#23576a' : '#bebfbe' }}
                  checked={journalVoucher?.isUsingPoints}
                  onChange={(e) => handleSwitch(e)} />
              </Col>
            </Row>

            {journalVoucher?.isUsingPoints &&
              <Row className="mb-3">
                <Col md={12}>
                  <InputGroup>
                    <Form.Control
                      type="number"
                      step={"any"}
                      onChange={(e) => handleInput(e)}
                      value={isUsingMainCurrency ? journalVoucher?.pointsValue : journalVoucher?.secondaryPointsValue}
                      placeholder="Enter printing phone"
                    />
                  </InputGroup>
                </Col>
              </Row>
            }
          </>
        }
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button type="primary" size="large" loading={loadingEffect} onClick={closeModal}
            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }} danger>Done</Button>
        </div>
      </Modal.Footer>

    </Modal>

  );
}

export default CustomerModal;
